import React from 'react';


import { SelectPicker } from "rsuite";

export const Select = ({onChange = (v) => v , ...props}) => {
    // RSuite treats undefined as uncontrolled; a cleared form field must stay controlled.
    const valueProps = Object.prototype.hasOwnProperty.call(props, "value")
        ? { value: props.value === undefined ? null : props.value }
        : {};

    return (
        <SelectPicker
            onChange={(value) => onChange(value === null ? undefined : value)}
            {...props}
            {...valueProps}
        />
    )
};

export default Select;
